// extracted by mini-css-extract-plugin
export default {"root":"oGCytcUEA9cIFvxehJ0f"};